export const PING_INIT = "ping.PING_INIT";
export const PING_SUCCESS = "ping.PING_SUCCESS";
export const PING_FAILURE = "ping.PING_FAILURE";